import { action } from 'satcheljs';
import type { ActionMessage } from 'satcheljs';

export interface ShowBriefingReplySendingToastActionMessage extends ActionMessage {
    composeId: string;
    durationSeconds: number;
}

/**
 * Fired by the mail compose stack when a briefing pre-drafted reply enters its
 * delay-send (undo) window. The PersonalOS UI layer owns the toast presentation
 * — it can reach the notification bar and locstrings — so the compose stack
 * triggers it through this lightweight action instead of importing PersonalOS
 * toast internals (which would pull the PersonalOS toast bundle into the mail
 * compose chunk). Undo routes back via `onBriefingReplySendUndone`.
 */
export const showBriefingReplySendingToast: (
    composeId: string,
    durationSeconds: number
) => ShowBriefingReplySendingToastActionMessage = action(
    'showBriefingReplySendingToast',
    (composeId: string, durationSeconds: number) => ({
        composeId,
        durationSeconds,
    })
);

export interface OnBriefingReplySendUndoneActionMessage extends ActionMessage {
    composeId: string;
}

/**
 * Fired when the user clicks Undo on the briefing reply sending toast. The mail
 * compose stack listens, cancels the queued delay-send, and re-arms tracking so
 * a resend shows the toast again. Keeping the undo handling in the compose stack
 * lets it read the live draft item id lazily (the draft may still be saving when
 * the undo window opens).
 */
export const onBriefingReplySendUndone: (
    composeId: string
) => OnBriefingReplySendUndoneActionMessage = action(
    'onBriefingReplySendUndone',
    (composeId: string) => ({
        composeId,
    })
);
